import { useLocation, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactPopup from '../components/ContactPopup';

const NotFound = () => {
  const location = useLocation();

  // Popup state management
  const [popupState, setPopupState] = useState({
    isOpen: false,
    title: "Get in Touch",
    subtitle: "Connect with our admissions team to learn more about our programs",
    formType: "popup_inquiry",
    interestedProgram: ""
  });

  const openPopup = (config: {
    title?: string;
    subtitle?: string;
    formType?: string;
    interestedProgram?: string;
  } = {}) => {
    setPopupState({
      isOpen: true,
      title: config.title || "Get in Touch",
      subtitle: config.subtitle || "Connect with our admissions team to learn more about our programs",
      formType: config.formType || "popup_inquiry",
      interestedProgram: config.interestedProgram || ""
    });
  };

  const closePopup = () => {
    setPopupState(prev => ({ ...prev, isOpen: false }));
  };

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-white">
      <Header openPopup={openPopup} />
      <div className="flex items-center justify-center py-20">
        <div className="text-center max-w-md mx-auto px-4">
          <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
          <p className="text-gray-600 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          
          <div className="space-y-4">
            <Link 
              to="/" 
              className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-200"
            >
              Return to Home
            </Link>
            
            <div className="flex flex-col space-y-2 text-sm">
              <p className="text-gray-500">Or visit one of these pages:</p>
              <div className="flex flex-wrap justify-center gap-4">
                <Link to="/privacy-policy" className="text-blue-600 hover:text-blue-800 underline">
                  Privacy Policy
                </Link>
                <Link to="/refund-policy" className="text-blue-600 hover:text-blue-800 underline">
                  Refund Policy
                </Link>
                <Link to="/terms-of-service" className="text-blue-600 hover:text-blue-800 underline">
                  Terms of Service
                </Link>
              </div>
            </div>
          </div>
          
          <p className="text-xs text-gray-400 mt-8">
            Error Code: 404 | Route: {location.pathname}
          </p>
        </div>
      </div>
      <Footer />
      
      <ContactPopup
        isOpen={popupState.isOpen}
        onClose={closePopup}
        title={popupState.title}
        subtitle={popupState.subtitle}
        formType={popupState.formType}
        interestedProgram={popupState.interestedProgram}
      />
    </div>
  );
};

export default NotFound;
